// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyARb7P_dve1CSyiRDvT4jllumeEfIcb1kM",
  authDomain: "todo-per-two-hour.firebaseapp.com",
  projectId: "todo-per-two-hour",
  storageBucket: "todo-per-two-hour.appspot.com",
  messagingSenderId: "10628937176",
  appId: "1:10628937176:web:004b6ca8e97acfb9ce6ead",
  measurementId: "G-22GM8VKX04",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
